<template>
  <div>
    <vk-offcanvas flipped overlay stuck :show.sync="showCanvas">
      <vk-offcanvas-close @click="showCanvas = false"></vk-offcanvas-close>
      <h3>Settings/Current Settings</h3>
      <!-- <hr /> -->
      <el-tabs :tab-position="`top`" style="height: 100%">
        <el-tab-pane label="Settings">
          <element-pending-info
            :pending-changes="pendingChanges"
          ></element-pending-info>
          <div>
            <el-collapse>
              <el-collapse-item title="Parameter Command Settings" name="1">
                <div class="inside">
                  <div class>
                    <!--  -->
                    <element-control-new
                      enable-action="PEa"
                      disable-action="PDa"
                      @refresh="refresh"
                      name="Silence Buzzer"
                      desc="Enable/Disable Silence Buzzer"
                    ></element-control-new>
                    <!--  -->
                    <element-control-new
                      enable-action="PEb"
                      disable-action="PDb"
                      @refresh="refresh"
                      name="Bypass Function"
                      desc="Enable/Disable Bypass Function"
                    ></element-control-new>
                    <!--  -->
                    <element-control-new
                      enable-action="PEj"
                      disable-action="PDj"
                      name="Power Saving"
                      @refresh="refresh"
                      desc="Enable/Disable Power Saving"
                    ></element-control-new>
                    <!--  -->
                    <element-control-new
                      enable-action="PEk"
                      disable-action="PDk"
                      name="LCD Display Escape"
                      @refresh="refresh"
                      desc="Enable/Disable LCD Display Escape after 1min timeout"
                    ></element-control-new>
                    <!--  -->
                    <element-control-new
                      enable-action="PEu"
                      disable-action="PDu"
                      name="Overload Restart"
                      @refresh="refresh"
                      desc="Enable/Disable Overload Restart"
                    ></element-control-new>
                    <!--  -->
                    <element-control-new
                      enable-action="PEv"
                      disable-action="PDv"
                      name="Temperature Restart"
                      @refresh="refresh"
                      desc="Enable/Disable Temperature Restart"
                    ></element-control-new>
                    <!--  -->
                    <element-control-new
                      enable-action="PEx"
                      disable-action="PDx"
                      name="Backlight ON"
                      @refresh="refresh"
                      desc="Enable/Disable Backlight ON"
                    ></element-control-new>
                    <!--  -->
                    <element-control-new
                      enable-action="PEy"
                      disable-action="PDy"
                      name="Alarm ON"
                      @refresh="refresh"
                      desc="Enable/Disable Alarm ON when primary source interrupt"
                    ></element-control-new>
                    <!--  -->
                    <element-control-new
                      enable-action="PEz"
                      disable-action="PDz"
                      name="Faut Code Record"
                      desc="Enable/Disable Faut Code Record"
                      @refresh="refresh"
                    ></element-control-new>
                  </div>
                </div>
              </el-collapse-item>
              <!--  -->
              <el-collapse-item
                title="Setting utility max charging current"
                name="2"
              >
                <div class="inside">
                  <div class>
                    <!--  -->
                    <element-control-radio
                      :items="[
                        { name: '2A', action: 'MUCHGC002' },
                        { name: '10A', action: 'MUCHGC010' },
                        { name: '30A', action: 'MUCHGC030' },
                        { name: '50A', action: 'MUCHGC050' },
                        { name: '60A', action: 'MUCHGC060' }
                      ]"
                      name="Utility max charging current"
                      desc="Select max charging current option"
                      @refresh="refresh"
                    ></element-control-radio>
                  </div>
                </div>
              </el-collapse-item>
              <!--  -->
              <el-collapse-item
                title="Setting Inverter output source priority"
                name="3"
              >
                <div class="inside">
                  <div class>
                    <element-control-radio
                      :items="[
                        { name: 'Utility-Solar-Battery', action: 'POP00' },
                        { name: 'Solar-Utility-Battery', action: 'POP01' },
                        { name: 'Solar-Battery-Utility', action: 'POP02' }
                      ]"
                      name="Inverter output source priority"
                      desc="Select Inverter output source priority"
                      @refresh="refresh"
                    ></element-control-radio>
                  </div>
                </div>
              </el-collapse-item>
              <!--  -->
              <el-collapse-item title="Set battery re-charge voltage" name="4">
                <div class="inside">
                  <div class>
                    <element-control-radio
                      :items="[
                        { name: '44V', action: 'PBCV44.0' },
                        { name: '45V', action: 'PBCV45.0' },
                        { name: '46V', action: 'PBCV46.0' },
                        { name: '47V', action: 'PBCV47.0' },
                        { name: '48V', action: 'PBCV48.0' },
                        { name: '49V', action: 'PBCV49.0' },
                        { name: '50V', action: 'PBCV50.0' },
                        { name: '51V', action: 'PBCV51.0' }
                      ]"
                      name="Set battery re-charge voltage"
                      desc="Select Set battery re-charge voltage"
                      @refresh="refresh"
                    ></element-control-radio>
                  </div>
                </div>
              </el-collapse-item>
              <!--  -->
              <el-collapse-item
                title="Set battery re-discharge voltage"
                name="5"
              >
                <div class="inside">
                  <div class>
                    <element-control-radio
                      :items="[
                        { name: '0V', action: 'PBDV00.0' },
                        { name: '48V', action: 'PBDV48.0' },
                        { name: '49V', action: 'PBDV49.0' },
                        { name: '50V', action: 'PBDV50.0' },
                        { name: '51V', action: 'PBDV51.0' },
                        { name: '52V', action: 'PBDV52.0' },
                        { name: '53V', action: 'PBDV53.0' },
                        { name: '54V', action: 'PBDV54.0' },
                        { name: '55V', action: 'PBDV55.0' },
                        { name: '56V', action: 'PBDV56.0' },
                        { name: '57V', action: 'PBDV57.0' },
                        { name: '58V', action: 'PBDV58.0' }
                      ]"
                      name="Set battery re-discharge voltage"
                      desc="Select Set battery re-discharge voltage"
                      @refresh="refresh"
                    ></element-control-radio>
                  </div>
                </div>
              </el-collapse-item>
              <!--  -->
              <el-collapse-item
                title="Setting Inverter charger priority"
                name="6"
              >
                <div class="inside">
                  <div class>
                    <element-control-radio
                      :items="[
                        {
                          name: 'SBL UCD',
                          action: 'PCP00',
                          desc:
                            'Allow AC charge battery, and solar charge battery first and then power load'
                        },
                        {
                          name: 'SBL UDC',
                          action: 'PCP01',
                          desc:
                            'Disallow AC charge battery, and solar charge battery first and then power load'
                        },
                        {
                          name: 'SLB UCD',
                          action: 'PCP02',
                          desc:
                            'Allow AC charge battery, and solar power load first and then charge battery'
                        },
                        {
                          name: 'SLB UDC',
                          action: 'PCP03',
                          desc:
                            'Disallow AC charge battery, and solar power load first and then charge battery'
                        }
                      ]"
                      name="Setting Inverter charger priority"
                      desc="Select Setting Inverter charger priority"
                      @refresh="refresh"
                    ></element-control-radio>
                  </div>
                </div>
              </el-collapse-item>
              <el-collapse-item title="Installed solar PV capacity" name="7">
                <element-current-input
                  eventKey="InstalledPV"
                  :topic="$route.params.deviceId"
                  @refresh="refresh"
                />
              </el-collapse-item>
              <el-collapse-item title="Contractual load for system" name="8">
                <element-current-input
                  eventKey="CLoad"
                  :topic="$route.params.deviceId"
                  @refresh="refresh"
                />
              </el-collapse-item>
            </el-collapse>
          </div>
        </el-tab-pane>
        <el-tab-pane label="Current Settings">
          <element-current-settings
            :getDeviceCurrentSettings="currentSettings"
          />
        </el-tab-pane>
      </el-tabs>
    </vk-offcanvas>
    <button @click="showCanvas = true" type="button" class="control-button">
      <i class="fa fa-cog" aria-hidden="true" style="font-size: 16px"></i>
    </button>
  </div>
</template>

<script>
/* eslint-disable */
import Vue from "vue";
import moment from "moment";
// import { HTTP as IOTHTTP } from "@/store/actions";
import { mapGetters, mapActions } from "vuex";

import { Offcanvas, OffcanvasClose } from "vuikit/lib/offcanvas";
import ElementControlNew from "./element-control-new";
import ElementControlRadio from "./element-control-radio";
import ElementPendingInfo from "./element-pending-info";
import CurrentSettings from "./current-settings";
import ElementControInput from "./element-control-input.vue";
import payloadDictionary from "../../../pages/performance/payload_dictionary.json";

export default {
  name: "controlSettings",
  components: {
    "vk-offcanvas": Offcanvas,
    "vk-offcanvas-close": OffcanvasClose,
    "element-control-new": ElementControlNew,
    "element-control-radio": ElementControlRadio,
    "element-pending-info": ElementPendingInfo,
    "element-current-settings": CurrentSettings,
    "element-current-input": ElementControInput
  },
  computed: {
    // ...mapGetters(["DeviceList", "graphDeviceDetails"])
  },
  data: function() {
    return {
      showCanvas: false,
      pendingChanges: null,
      currentSettings: {}
    };
  },
  methods: {
    async getPendingChanges() {
      const deviceId = this.$route.params.deviceId;

      const HTTP = this.$httpUtils.instance;
      const endpoint = `${this.$utilConstants.IOT_BASE_URL}/devicestate/`;

      const res = await HTTP.get(`${endpoint}${deviceId}`);
      if (
        res &&
        res.data &&
        res.data.state &&
        res.data.state.delta &&
        res.data.state.delta
      ) {
        return res.data.state.delta;
      }
    },
    async graphDetailsCall() {
      const cid = this.$route.params.deviceId;
      this.deviceId = cid;
      if (!cid) {
        return true;
      }

      const GraphHTTP = this.$httpUtils.GraphHTTP;
      let data = {
        query: `{
        device(id: ${cid} )
      }`
      };
      return await GraphHTTP.post("/graphql", data)
        .then(async res => {
          console.log("---> response V3 <----");
          let _tmpDevice = res.data.data.device["Items"][0];
          let parsed = await this.transformDashData(
            _tmpDevice,
            res.data.data.device
          );
          // console.log({ parsed });
          let tParsed = await this.transformListData(parsed);
          // console.log({ tParsed });
          return tParsed;
        })
        .catch(err => {
          console.log(err);
          return [{ DeviceID: this.deviceId }];
        });
    },
    transformMapData(MapData) {
      return Object.keys(MapData).reduce((cummData, key) => {
        let oldKey = payloadDictionary.find(x => x.new_key == key);
        if (oldKey && oldKey["old_key"] != "") {
          cummData[oldKey["old_key"]] = MapData[key];
        } else {
          cummData[key] = MapData[key];
        }
        return cummData;
      }, {});
    },
    transformDashData(_tmpDevice, _completePayload = null) {
      let { currentSettings } = _completePayload;
      // return currentSettings;
      let currentSettingsAndDeviceId = currentSettings.map(x => ({
        ...x,
        DeviceID: this.deviceId
      }));
      return currentSettingsAndDeviceId;
    },
    transformListData(ListData) {
      return ListData.map(x => {
        // Object.keys(x).map(key => {
        //   x[payloadDictionary.find(x => x.new_key == key)["old_key"]] = x[key];
        //   delete x[key];
        // });
        return x.length ? this.transformListData(x) : this.transformMapData(x);
      });
    },
    async refresh() {
      this.pendingChanges = await this.getPendingChanges();
      let response = await this.graphDetailsCall();
      this.currentSettings = response.length > 0 ? response[0] : {};
    }
  },
  created() {},
  async mounted() {
    this.pendingChanges = await this.getPendingChanges();
    let response = await this.graphDetailsCall();
    this.currentSettings = response.length > 0 ? response[0] : {};
  }
};
</script>

<style lang="scss" scoped>
.control-button {
  background-color: white;
  border: 1px solid #d3d9dd;
  padding: 0.7rem 2.1rem;
  cursor: pointer;

  &:hover {
    background-color: transparent;
  }
}

.inside {
  padding: 12px;
}

.grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
}

.uk-offcanvas-bar {
  width: 35em !important;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/performance/controls/index.vue